export class CriteriaGroup{
    caption: string = '';
    conditions?: ConditionCriteriaGroup[] | null = [];
    isElse: boolean = false;
    logic?: string;
    constructor (caption: string, isElse?:boolean, conditions?:ConditionCriteriaGroup[]){
        this.caption = caption;
        if(isElse){
            this.conditions = null;
            this.isElse = isElse;
        }
        this.conditions = conditions;
        if(this.conditions && this.conditions.length > 1){
            this.logic = Logic.AND;
        }
    }
}

export class ConditionCriteriaGroup {
    columnCaption?: string;
    column?: string;
    operator?: string;
    values: string[] = [];
    value?: string;
}

export enum ComparisonOperator {
    IN = 'IN',
    NOT_IN = 'NOT IN',
    GREATER = '>',
    EQUAL = '=',
    LOWER = '<',
    GREATER_EQUAL = '>=',
    LOWER_EQUAL = '<=',
}

export enum Logic {
    AND = 'AND',
    OR = 'OR'
}

// If it's used by more than one class, move it to a general util class
export class HisOption{
    label: string;
    id: string;
    constructor(label: string, id: string){
        this.label = label;
        this.id = id;
    }
}
